import { LabeledPrice } from 'src/graphql'
import { formatCost, sumCurrencyTypes } from 'src/helpers'

const lineTotalMinusGift = (entries: LabeledPrice[], multiplier = 1) => {
  return entries
    ? sumCurrencyTypes(
        entries.filter(
          e => !e.label.includes('Gift') && e.label !== 'Shipping',
        ),
        multiplier,
      )
    : formatCost(0)
}

export default lineTotalMinusGift
